import omit from "lodash/omit";

import {
  AlgoliaMultiselect,
  AlgoliaMultiselectProps,
} from "@/components/pieces/algolia/AlgoliaMultiselect";

export function JobTitleMultiselect({
  selections,
  filters,
  ...props
}: AlgoliaMultiselectProps) {
  const localFilters = ["usage_count >= 200"].concat(
    (selections || []).map(
      (s) => `NOT normalized_title:"${s.normalizedTitle}"`,
    ),
  );

  if (filters) localFilters.push(`(${filters})`);

  const newProps = omit(props, "selections", "filters");

  return (
    <AlgoliaMultiselect
      filters={localFilters.join(" AND ")}
      suggestionConverter={(suggestion) => ({
        ...suggestion,
        title: suggestion.title,
        normalizedTitle: suggestion.normalized_title,
      })}
      renderSuggestion={(suggestion) => <div>{suggestion.title}</div>}
      getSuggestionValue={(suggestion) => suggestion.title}
      placeholder="ie. Account Manager"
      {...newProps}
    />
  );
}
